import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { UilTimes, UilAngleRight, UilAngleLeft, UilExclamationCircle } from '@iconscout/react-unicons'
import InterviewContainer from './InterviewContainer'

const ModalTry = ({ isOpen, onRequestClose, question, handleNextQuestion, handlePrevQuestion, handleSaveAnswer, currentQuestionIndex, totalQuestions }) => {
  const [textareaValue, setTextareaValue] = useState('');
  const [optionValue, setOptionValue] = useState('');
  
  useEffect(() => {
    if((question.get('type_parent')=='smart_question' && question.get('type_child')=='freetext')){
      setTextareaValue(question.get('user_answer') || '');
    }else if(question.get('type_parent')=='smart_question' && question.get('type_child')!='freetext'){
      setOptionValue(question.get('user_answer') || '');
    }
    
  }, [question]);

  const handleTextareaChange = (e) => {
    if(getWordCount(e.target.value) > maxWords){
      e.preventDefault();
      return false;
    }else{
      handleSaveAnswer(e, currentQuestionIndex, question.get('id'), 'freetext', e.target.value)
      setTextareaValue(e.target.value);
    }
  };
  
  const handlePaste = (e) => {
    e.preventDefault();
    return false;
  };
  
  const handleCopy = (e) => {
    e.preventDefault();
    return false;
  };
  
  const handleCut = (e) => {
    e.preventDefault();
    return false;
  };
  
  const getWordCount = (text) => {
    if (!text.trim()) return 0;
    return text.trim().split(/\s+/).length;
  };
  
  const wordCount = getWordCount(textareaValue);
  // const maxWords = question.get('max_length') || 100;
  const maxWords = 5;
  // const minWords = question.get('min_length') || 0;
  const minWords = 1;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Try Assessment Modal"
      ariaHideApp={false}
      className="modal-try"
    >
      <div className="modal-try-container">
        {/* Header */}
        <div className="modal-try-header">
          <button 
            className="modal-close-btn"
            onClick={onRequestClose}
          >
            <UilTimes size={28} />
          </button>
        </div>

        {/* Content Area */}
        <div className="modal-try-content">
          <h5>{question.get('title')}</h5>
          {/* Content will be added here */}
          {
            question.get('type_parent')=='rating_scale_question' && <div className="rating-scale">
              <div className="rating-scale-container horizontal-item--between">
              {
                question.get('answers').map((answer, index) => (
                    <button className={`btn-rating-scale ${answer.get('id') == question.get('user_answer') ? 'checked' : ''}`} key={index} onClick={(e) => handleSaveAnswer(e, currentQuestionIndex,question.get('id'), 'rating_scale', answer.get('id'))}></button>
                ))
              }
              </div>

              <div className="rating-scale-option horizontal-item--between">
                {
                  question.get('answers').map((answer, index) => (  
                    <label key={index}>{answer.get('label')}</label>
                  ))
                }
              </div>
            </div>
          }

          {
            (question.get('type_parent')=='smart_question' && question.get('type_child')!='freetext') && <div className="mcq">
            <span>Select one correct answer</span>
            <div className="options">
              {
                question.get('answers').map((answer, index) => (
                  <label key={index}>
                    <button className={`btn-mcq ${answer.get('id') == optionValue ? 'checked' : ''}`} onClick={(e) => handleSaveAnswer(e, currentQuestionIndex, question.get('id'), 'mcq', answer.get('id'))}>{answer.get('answer_label')}</button>
                    {answer.get('label')}
                  </label>
                ))
              }
            </div>
          </div>
          }

          {
            (question.get('type_parent')=='smart_question' && question.get('type_child')=='freetext')  && <div className="ftq">
            {/* <span>Select one correct answer</span> */}
                <textarea 
                  placeholder="Enter your answer"
                  onKeyUp={(e)=>handleSaveAnswer(e, currentQuestionIndex, question.get('id'), 'freetext', e.target.value)}
                  value={textareaValue}
                  onChange={handleTextareaChange}
                  onPaste={handlePaste}
                  onCopy={handleCopy}
                  onCut={handleCut}
                  onContextMenu={(e) => e.preventDefault()}
                />
                <div className="ftq-footer">
                  <div className="copy-paste">
                    <UilExclamationCircle size={20} color="#E99F0C" /><span>Copy-pasting is not allowed</span>
                  </div>
                  <p>{wordCount} / {maxWords} Words (min. {minWords} words)</p>
                </div>
          </div>
          }

          {
            question.get('type_parent')=='video_question' && <div className="video-question">
            <InterviewContainer isOpen={isOpen} question={question} handleSaveAnswer={handleSaveAnswer} currentQuestionIndex={currentQuestionIndex} />
          </div>
          }
          
        </div>

        {/* Footer */}
        <div className="modal-try-footer">
          <div className="footer-left">
            {
              currentQuestionIndex > 0 && <button disabled={currentQuestionIndex == 0} className="btn-secondary" onClick={(e) => handlePrevQuestion(e, question.get('id'))}>
              <UilAngleLeft size={26} /> Previous
            </button>
            }
          </div>
          <div className="footer-right">
            <button className={`btn-primary ${currentQuestionIndex == totalQuestions - 1 ? 'use-now' : ''}`} onClick={(e) => handleNextQuestion(e, question.get('id'))}>
              {currentQuestionIndex == totalQuestions - 1 ? 'Use Now For Free' : 'Next'} <UilAngleRight size={26} />
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalTry
